import { HealthAndSafetyNotification } from "@Components/game/health-and-safety/health-and-safety-notification";
import { Api } from "@Shared/schemas";
import { useApi, useGlobalContext } from "@hooks/index";
import useI18n from "@i18n";
import { useHealthNotes } from "./use-health-notes";

export const HealthAndSafetyService = () => {
  const { locale, isLocaleReady } = useI18n();
  const { globalState } = useGlobalContext();
  const { call } = useApi({ api: Api.Notes.GetHealthNotes, disableLoader: true });
  const { note, advance } = useHealthNotes({
    locale,
    enabled: globalState.app.initialized && isLocaleReady,
    loadNotes: call,
  });

  return <HealthAndSafetyNotification note={note} onElapsed={advance} />;
};
